import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Palette, MessageSquare, FileSpreadsheet, Users, TrendingUp, Receipt, Star } from 'lucide-react';

// ── HERRAMIENTAS NUEVAS (PRO y VIP) ──────────────────────────────────────
const newTools = [{
  icon: FileSpreadsheet,
  tag: 'PRO + VIP',
  tagColor: 'text-cyan-400 bg-cyan-500/10 border-cyan-500/20',
  title: 'Módulo de Fiados y Crédito',
  description: 'Registra cada fiado con fecha, cliente, monto en $ y Bs, fecha límite y estado. El sistema calcula automáticamente los días restantes y te muestra el total pendiente por cobrar en tiempo real.',
  accentColor: 'from-cyan-500/20 to-cyan-500/5',
  borderHover: 'hover:border-cyan-500/40'
}, {
  icon: Users,
  tag: 'PRO + VIP',
  tagColor: 'text-cyan-400 bg-cyan-500/10 border-cyan-500/20',
  title: 'Comparación de Proveedores',
  description: 'Compara hasta 4 proveedores del mismo producto. Ingresa nombre, precio y calidad del 1 al 10 — el sistema elige automáticamente cuál tiene la mejor relación precio/calidad.',
  accentColor: 'from-blue-500/20 to-blue-500/5',
  borderHover: 'hover:border-blue-500/40'
}, {
  icon: TrendingUp,
  tag: 'Solo VIP',
  tagColor: 'text-green-400 bg-green-500/10 border-green-500/20',
  title: 'Empleados y Comisiones',
  description: 'Hasta 15 empleados con sueldo base, comisión por ventas y adelantos. El total neto a pagar se calcula automáticamente cada período. Tu nómina en 5 minutos.',
  accentColor: 'from-green-500/20 to-green-500/5',
  borderHover: 'hover:border-green-500/40'
}, {
  icon: Receipt,
  tag: 'Solo VIP',
  tagColor: 'text-yellow-400 bg-yellow-500/10 border-yellow-500/20',
  title: 'Sistema de Cotizaciones Profesionales',
  description: 'Genera presupuestos formales con datos de tu negocio, precios en $ y Bs automáticos, IVA opcional y número correlativo. Listos para imprimir o enviar como PDF por WhatsApp.',
  accentColor: 'from-yellow-500/20 to-yellow-500/5',
  borderHover: 'hover:border-yellow-500/40'
}];

// ── BONOS INCLUIDOS EN TODOS LOS PLANES ──────────────────────────────────
const bonuses = [{
  title: '100 Plantillas Pro (Canva) para Negocios',
  description: 'Olvídate de pagar diseñadores. Te regalamos 50 posts y 50 historias diseñadas para detener el scroll y atraer clientes a tu local.',
  value: '$47',
  image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/hero-impact.jpg?v=1773383734',
  icon: Palette
}, {
  title: 'Pack de Scripts de Venta (WhatsApp)',
  description: 'La ruta exacta para manejar objeciones. Sabrás qué decir para que dejen de decirte "está caro" y empiecen a pedirte los datos de pago.',
  value: '$19',
  image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_m9n9i7m9n9i7m9n9.jpg?v=1773379810',
  icon: MessageSquare
}];
export function Bonuses() {
  return <section className="relative py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-17">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-cyan-500/8 rounded-full blur-[120px] pointer-events-none" data-id="element-18" />

      {/* ── SECCIÓN 1: NUEVAS HERRAMIENTAS ── */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} className="text-center mb-12 relative z-10" data-id="element-19">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-sm font-bold mb-5 uppercase tracking-widest" data-id="element-20">
          <Star className="w-4 h-4" data-id="element-21" /> Módulos Exclusivos — Herramientas Premium
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight" data-id="element-22">
          Herramientas que{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-23">
            ningún otro sistema tiene
          </span>
        </h2>
        <p className="text-gray-400 mt-4 text-lg max-w-2xl mx-auto font-light" data-id="element-24">
          Disponibles en los planes PRO y VIP. Diseñadas específicamente para los problemas reales
          de los negocios venezolanos.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 relative z-10 mb-20" data-id="element-25">
        {newTools.map((tool, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className={`group bg-[#0a0a0a] border border-white/8 rounded-2xl p-6 ${tool.borderHover} transition-all duration-300 relative overflow-hidden`} data-id="element-26">
            <div className={`absolute inset-0 bg-gradient-to-br ${tool.accentColor} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-27" />
            <div className="relative z-10" data-id="element-28">
              <div className="flex items-start justify-between mb-4" data-id="element-29">
                <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center border border-white/10 group-hover:scale-110 transition-transform duration-300" data-id="element-30">
                  <tool.icon className="w-6 h-6 text-white" data-id="element-31" />
                </div>
                <span className={`text-xs font-bold px-3 py-1 rounded-full border ${tool.tagColor}`} data-id="element-32">
                  {tool.tag}
                </span>
              </div>
              <h3 className="font-heading text-lg font-bold text-white mb-3" data-id="element-33">{tool.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-34">{tool.description}</p>
            </div>
          </motion.div>)}
      </div>

      {/* ── SECCIÓN 2: BONOS GRATIS ── */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} className="text-center mb-12 relative z-10" data-id="element-35">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-bold mb-5 uppercase tracking-widest" data-id="element-36">
          <Gift className="w-4 h-4" data-id="element-37" /> Bonos Exclusivos — Incluidos en todos los planes
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight" data-id="element-38">
          ¡Y eso no es todo! Llévate estos bonos{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-39">
            100% GRATIS
          </span>
        </h2>
        <p className="text-gray-400 mt-4 text-lg max-w-2xl mx-auto font-light" data-id="element-40">
          Solo por adquirir tu plan hoy, te incluimos estas herramientas premium sin costo adicional.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 relative z-10" data-id="element-41">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: index * 0.2
      }} className="group relative bg-[#0a0a0a] border border-white/10 rounded-3xl overflow-hidden hover:border-cyan-500/40 transition-all duration-500 shadow-2xl flex flex-col" data-id="element-42">
            <div className="absolute top-4 right-4 bg-gradient-to-r from-cyan-400 to-green-400 text-black font-black text-sm px-5 py-2 rounded-full z-20 shadow-lg transform rotate-3 group-hover:scale-110 transition-transform duration-300" data-id="element-43">
              ¡GRATIS HOY!
            </div>

            <div className="relative w-full aspect-square overflow-hidden border-b border-white/10" data-id="element-44">
              <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-45" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent z-10 opacity-60" data-id="element-46" />
            </div>

            <div className="relative z-20 p-8 flex-1 flex flex-col justify-between" data-id="element-47">
              <div data-id="element-48">
                <h3 className="font-heading text-2xl font-bold text-white mb-3 tracking-tight group-hover:text-cyan-400 transition-colors duration-300" data-id="element-49">
                  <span className="text-cyan-500 mr-2 text-lg uppercase block mb-1" data-id="element-50">
                    Bono {index + 1}:
                  </span>
                  {bonus.title}
                </h3>
                <p className="text-gray-400 leading-relaxed mb-6 text-lg font-light" data-id="element-51">
                  {bonus.description}
                </p>
              </div>

              <div className="inline-flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-5 py-3 text-sm text-gray-300 w-fit" data-id="element-52">
                <span data-id="element-53">Valorado en:</span>
                <span className="text-rose-400 line-through font-bold text-lg" data-id="element-54">{bonus.value}</span>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}